import get from 'lodash/get';
import { createReducer } from '@reduxjs/toolkit';
import * as actions from 'store/findProvider/actions';
import * as types from 'store/findProvider/types';
import { Nullable } from 'modules/types/common';

const languageInitialState = {
  isFetching: false,
  data: [] as types.Language[],
  error: null as Nullable<Error>
};

export type LanguageState = typeof languageInitialState;

export const languagesReducer = createReducer(languageInitialState, {
  [actions.PROVIDER_GET_LANGUAGES]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.PROVIDER_GET_LANGUAGES_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.data = get(action, 'payload.data') || [];
  },
  [actions.PROVIDER_GET_LANGUAGES_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  }
});

export default languagesReducer;
